interface Pagination {
    currentPage: number;
    perPage: number;
    total: number;
}

// Some BE endpoints return the wrong sort of pagination and we need to be able to detect and deal with that.
// FE should never create structures using this.
interface PythonPagination {
    current_page: number;
    per_page: number;
    total: number;
}

export interface PaginatedData<T> {
    data: T;
    latestDate: string;
    pagination: Pagination;
}

export interface PaginationQuery {
    currentPage: number;
    perPage?: number;
}

export const isPagination = (pagination: Pagination | PythonPagination): pagination is Pagination => {
    return pagination != null && Object.hasOwn(pagination, 'currentPage') && Object.hasOwn(pagination, 'perPage');
};

export const isPythonPagination = (pagination: Pagination | PythonPagination): pagination is PythonPagination => {
    return pagination != null && Object.hasOwn(pagination, 'current_page') && Object.hasOwn(pagination, 'per_page');
};

export const normalizedPagination = (pagination: Pagination | PythonPagination): Pagination => {
    if (isPagination(pagination)) {
        return pagination;
    }

    if (isPythonPagination(pagination)) {
        return {
            currentPage: pagination.current_page,
            perPage: pagination.per_page,
            total: pagination.total,
        };
    }

    return {
        currentPage: 1,
        perPage: 0,
        total: 0,
    };
};
